import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@icon/sprint-alert.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_NotificationSprintHeader = _resolveComponent("NotificationSprintHeader")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, { notification: _ctx.notification }, {
    pic: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["label-pic", [_ctx.labelColor]])
      }, [
        _createVNode(_component_icon, {
          data: _imports_0,
          class: "label-pic__icon",
          fill: true,
          width: "var(--icon-24)",
          height: "var(--icon-24)"
        })
      ], 2)
    ]),
    title: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "medium",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "400"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Sprint Risk Alert ")
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "medium",
        color: "monochrome-07",
        weight: "500",
        className: "notification__sprint-alert"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_NotificationSprintHeader, { sprint: _ctx.sprintAlert }, {
            default: _withCtx(() => [
              _createTextVNode(" at Risk ")
            ]),
            _: 1
          }, 8, ["sprint"])
        ]),
        _: 1
      }),
      _createVNode(_component_BaseSubHeading, {
        size: "medium",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "400",
        className: "notification__sprint-alert"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" It looks like the time left for the work in "),
          _createElementVNode("b", null, "Sprint #" + _toDisplayString(_ctx.sprintAlert?.sprintSequenceNumber), 1),
          _createTextVNode(" exceeds the time available by "),
          _createElementVNode("span", {
            class: _normalizeClass([[_ctx.labelColor], "notification__sprint-alert__riskLevel"])
          }, "over " + _toDisplayString(_ctx.sprintAlert?.riskLevel) + "%", 3),
          _hoisted_1,
          _createTextVNode(" Please take this opportunity to review what's left. ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["notification"]))
}